import { JoPullToWipComponent } from "@/job-orders/jo-pull-to-wip.component";
import { JobOrdersComponent } from "@/job-orders/job-orders.component";
import { AuthGuardService } from "@/shared/auth-guard.service";
import { canDeactivateGuard } from "@/shared/can-deactivate-guard.service";
import { EntityManagerProviderGuard } from "@/shared/entity-manager-guard";
import { SharedModule } from "@/shared/shared.module";
import { NgModule } from "@angular/core";
import { ScanComponent } from "./scan.component";
import { scan } from "rxjs";
import { CommonModule } from "@angular/common";
import { ScanPullBatchesComponent } from "./scan-pull-batches.component";

export const routes = [
  {
    path: "scanner",
    component: ScanComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    canDeactivate: [canDeactivateGuard],
    children: [
      {
        path: "",
        component: ScanPullBatchesComponent,
        title: "Proximity Supplier",
      },
    ],
  },
];

@NgModule({
  declarations: [ScanComponent, ScanPullBatchesComponent],
  imports: [CommonModule, SharedModule],
})
export class ScannerModule {}
